export enum ApplicationCategory {
  Marriage = "Marriage",
  Divorce = "Divorce",
}

export enum ServiceCategory {
  WeddingCertificate = 1,
  DivorceCertificate = 2,
  Reprinting = 3,
}

export const ServiceCategoryLabels: Record<ServiceCategory, string> = {
  [ServiceCategory.WeddingCertificate]: "Marriage Certificate",
  [ServiceCategory.DivorceCertificate]: "Divorce Certificate",
  [ServiceCategory.Reprinting]: "Reprinting",
};

export enum CountyEnum {
  Bomi = 1,
  Bong = 2,
  Gbarpolu = 3,
  GrandBassa = 4,
  GrandCapeMount = 5,
  GrandGedeh = 6,
  GrandKru = 7,
  Lofa = 8,
  Margibi = 9,
  Maryland = 10,
  Montserrado = 11,
  Nimba = 12,
  RiverCess = 13,
  RiverGee = 14,
  Sinoe = 15,
  CentralOffice = 16,
}

export const CountyLabels: Record<CountyEnum, string> = {
  [CountyEnum.Bomi]: "Bomi",
  [CountyEnum.Bong]: "Bong",
  [CountyEnum.Gbarpolu]: "Gbarpolu",
  [CountyEnum.GrandBassa]: "Grand Bassa",
  [CountyEnum.GrandCapeMount]: "Grand Cape Mount",
  [CountyEnum.GrandGedeh]: "Grand Gedeh",
  [CountyEnum.GrandKru]: "Grand Kru",
  [CountyEnum.Lofa]: "Lofa",
  [CountyEnum.Margibi]: "Margibi",
  [CountyEnum.Maryland]: "Maryland",
  [CountyEnum.Montserrado]: "Montserrado",
  [CountyEnum.Nimba]: "Nimba",
  [CountyEnum.RiverCess]: "River Cess",
  [CountyEnum.RiverGee]: "River Gee",
  [CountyEnum.Sinoe]: "Sinoe",
  [CountyEnum.CentralOffice]: "Central Office",
};

export interface County {
  id: number;
  name: string;
}

export interface Nationality {
  id: number;
  name: string;
}

export interface CertificateApplication {
  id?: number;
  category: string;
  clientId?: number;
  clientName?: string;
  formNo: string;
  dateOfCertification: string;
  password?: string;
  email: string;
  placeOfWedding?: string;
  dateOfWedding?: string;
  countyId?: number;
  countyName?: string;
  county?: {
    id: number;
    name: string;
  };
  workflowId?: number;
  workflowName?: string;
  isCancelled?: boolean;
  processAtHeadquarters?: boolean;
  serviceCharge?: number;
  lraPayment?: number;
  operationalCost?: number;
  currencyId?: number;
  currencyName?: string;
  createdBy?: number;
  createdByName?: string;
  createdAt?: string;
  updatedAt?: string;
  groomName?: string;
  brideName?: string;
  plaintiffName?: string;
  defendantName?: string;
  status?: {
    id: number;
    name: string;
  };
  statusId?: number;
  statusName?: string;
}

export interface CreateCertificateApplicationDto {
  category: string;
  countyId: number;
  workflowId?: number;
  statusId?: number;
  dateOfCertification?: string;
  dateOfWedding: string;
  placeOfWedding: string;
  email?: string;
  processAtHeadquarters?: boolean;
  lraPayment?: number;
  operationalCost?: number;
  currencyId?: number;
}

export interface UpdateCertificateApplicationDto {
  id?: number;
  category?: string;
  countyId?: number;
  workflowId?: number;
  statusId?: number;
  dateOfCertification?: string;
  dateOfWedding?: string;
  placeOfWedding?: string;
  email?: string;
  processAtHeadquarters?: boolean;
  lraPayment?: number;
  operationalCost?: number;
  currencyId?: number;
}

export interface CertificateSignature {
  id: number;
  signedCertificateId: number;
  signatureType: string;
  signaturePath: string;
  createdBy: number;
  createdByName: string;
  createdAt: string;
}

export interface SignedCertificate {
  id: number;
  certificateApplicationId: number;
  documentPath: string;
  createdBy: number;
  createdByName: string;
  createdAt: string;
}

export interface AuthoritySignature {
  userId: number;
  signature: string; // Base64 encoded signature
}
